<template>
  <div class="row">
    <!-- Breadcrumb & Header -->
    <div class="col-12 mb-4">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-transparent p-0 mb-1">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'ListPayment' }" class="text-muted text-decoration-none">
                  {{ $t('superadmin.paymentChannelsTitle') }}
                </router-link>
              </li>
              <li class="breadcrumb-item active text-white" aria-current="page">
                {{ $t('superadmin.editPaymentMethod') }}
              </li>
            </ol>
          </nav>
          <h2 class="text-white font-weight-bold mb-1">{{ $t('superadmin.editPaymentMethod') }}</h2>
          <p class="text-muted small mb-0">{{ $t('superadmin.paymentChannelsSubtitle') }}</p>
        </div>
        <div>
          <button type="button" @click="back" class="btn btn-secondary">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-10 grid-margin">
      <div class="card">
        <div class="card-body">
          <div v-if="fetching" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">{{ $t('common.loading') }}</span>
            </div>
            <p class="text-muted mt-2">{{ $t('common.loading') }}</p>
          </div>

          <form v-else class="forms-sample" @submit.prevent="submitForm">
            <!-- Basic Info -->
            <h5 class="text-white font-weight-semibold mb-3 d-flex align-items-center">
              <i class="mdi mdi-information-outline text-primary mr-2" style="font-size: 20px;"></i>
              {{ $t('superadmin.channelInfo') }}
            </h5>

            <div class="form-group row">
              <div class="col-md-7 mb-3 mb-md-0">
                <label class="form-label text-muted small font-weight-medium">
                  {{ $t('superadmin.paymentMethodName') }} <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Virtual Account BCA Xendit' : 'e.g. Xendit Virtual Account BCA'"
                  v-model="paymentStore.paymentName"
                  required
                />
              </div>
              <div class="col-md-5">
                <label class="form-label text-muted small font-weight-medium">
                  {{ $t('superadmin.channelCode') }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: BCA_VA' : 'e.g. BCA_VA'"
                  v-model="paymentStore.code"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4 mb-3 mb-md-0">
                <label class="form-label text-muted small font-weight-medium">{{ $currentLocale === 'id' ? 'Tipe Integrasi' : 'Integration Type' }}</label>
                <select class="form-control" v-model="paymentStore.type">
                  <option value="digital">{{ $currentLocale === 'id' ? 'Gerbang Digital (Xendit/QRIS)' : 'Digital Gateway (Xendit/QRIS)' }}</option>
                  <option value="manual">{{ $currentLocale === 'id' ? 'Transfer Bank Manual' : 'Manual Bank Transfer' }}</option>
                  <option value="va">{{ $currentLocale === 'id' ? 'Akun Virtual' : 'Virtual Account' }}</option>
                  <option value="qris">{{ $currentLocale === 'id' ? 'QRIS Dinamis' : 'Dynamic QRIS' }}</option>
                </select>
              </div>
              <div class="col-md-4 mb-3 mb-md-0">
                <label class="form-label text-muted small font-weight-medium">
                  {{ $t('superadmin.baseFee') }} (Rp)
                </label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="0"
                  min="0"
                  v-model="paymentStore.price"
                />
              </div>
              <div class="col-md-4">
                <label class="form-label text-muted small font-weight-medium">{{ $t('common.status') }}</label>
                <select class="form-control" v-model="paymentStore.status">
                  <option value="Active">{{ $t('common.active') }}</option>
                  <option value="Inactive">{{ $t('common.inactive') }}</option>
                </select>
              </div>
            </div>

            <hr class="border-secondary my-4" />

            <!-- Account Details -->
            <h5 class="text-white font-weight-semibold mb-3 d-flex align-items-center">
              <i class="mdi mdi-bank-outline text-success mr-2" style="font-size: 20px;"></i>
              {{ $currentLocale === 'id' ? 'Rincian Rekening Tujuan' : 'Destination Bank Account Details' }}
            </h5>

            <div class="form-group row">
              <div class="col-md-6 mb-3 mb-md-0">
                <label class="form-label text-muted small font-weight-medium">{{ $t('billing.accountNumber') }}</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="5892 000 000"
                  v-model="paymentStore.account_number"
                />
              </div>
              <div class="col-md-6">
                <label class="form-label text-muted small font-weight-medium">{{ $t('billing.senderName') }} / {{ $currentLocale === 'id' ? 'Nama Penerima' : 'Beneficiary Name' }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: PT Gamiteam Digital Nusantara' : 'e.g. PT Gamiteam Digital Nusantara'"
                  v-model="paymentStore.account_name"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-12">
                <label class="form-label text-muted small font-weight-medium">{{ $currentLocale === 'id' ? 'Instruksi Pembayaran untuk Mitra Perusahaan' : 'Payment Instructions for Client Enterprise' }}</label>
                <textarea
                  class="form-control"
                  rows="3"
                  :placeholder="$currentLocale === 'id' ? 'Instruksi yang ditampilkan kepada mitra saat penyelesaian faktur...' : 'Instructions displayed to clients during invoice settlement...'"
                  v-model="paymentStore.instructions"
                ></textarea>
              </div>
            </div>

            <!-- Actions -->
            <div class="d-flex justify-content-end align-items-center gap-3 mt-4 pt-3 border-top border-secondary">
              <button
                type="button"
                @click="back"
                class="btn btn-secondary px-4 mr-2"
                :disabled="loading"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-primary px-4 d-inline-flex align-items-center"
                :disabled="loading"
              >
                <span
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                  v-if="loading"
                ></span>
                <i v-else class="mdi mdi-content-save mr-1"></i>
                {{ $t('common.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailPayment, updatePayment } from "../../services/paymentService";
import Swal from "sweetalert2";

export default {
  name: "PaymentEditView",
  data: () => ({
    id: null,
    paymentStore: {
      paymentName: "",
      code: "",
      type: "digital",
      price: 0,
      account_number: "",
      account_name: "",
      instructions: "",
      status: "Active",
    },
    fetching: true,
    loading: false,
  }),
  methods: {
    async loadPayment() {
      this.fetching = true;
      try {
        const res = await getDetailPayment(this.id);
        const data = res.data || res;
        this.paymentStore = {
          paymentName: data.name || data.paymentName || "",
          code: data.code || "",
          type: data.type || "digital",
          price: data.price || 0,
          account_number: data.account_number || "",
          account_name: data.account_name || "",
          instructions: data.instructions || "",
          status: data.status || "Active",
        };
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: this.$t('common.error'),
          text: this.$currentLocale === 'id' ? "Gagal memuat data metode pembayaran." : "Failed to load payment method data.",
          confirmButtonColor: "#3b82f6",
        });
        this.back();
      } finally {
        this.fetching = false;
      }
    },
    async submitForm() {
      if (!this.paymentStore.paymentName) {
        Swal.fire({
          icon: "warning",
          title: this.$currentLocale === 'id' ? "Field Wajib" : "Required Field",
          text: this.$currentLocale === 'id' ? "Silakan masukkan nama metode pembayaran." : "Please enter a payment method name.",
          confirmButtonColor: "#3b82f6",
        });
        return;
      }

      this.loading = true;
      try {
        await updatePayment(this.id, this.paymentStore);

        Swal.fire({
          icon: "success",
          title: this.$t('common.success'),
          text: this.$currentLocale === 'id' ? "Metode pembayaran berhasil diperbarui." : "Payment method updated successfully.",
          confirmButtonColor: "#3b82f6",
        });

        this.$router.push({ name: "ListPayment" });
      } catch (error) {
        const errors = error.response?.data?.errors;
        const errMsg = (errors && typeof errors === "object")
          ? Object.values(errors).flat()[0]
          : (error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? "Gagal memperbarui metode pembayaran" : "Failed to update payment method"));
        Swal.fire({
          icon: "error",
          title: this.$t('common.error'),
          text: errMsg,
          confirmButtonColor: "#3b82f6",
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.push({ name: "ListPayment" });
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.loadPayment();
  },
};
</script>
